module.exports = __webpack_public_path__ + "./fonts/ITCAvantGardePro-Md.ttf";